export default "__VITE_ASSET__dad61d90__"